import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.partTitle,
    sections: [
        createInvalidPartSection(),
        {
            sectionKey: 'missingTitle',
            sectionTitle: 'Missing Product Title',
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: 'partNumber',
                    label: 'Part Number',
                    type: 'text',
                    extractValue: (o) => typeof o === 'string' ? o : o?.partNumber ?? null,
                    modifyRow: (row, val) => ({...row, partNumber: val})
                },
                {
                    key: 'title',
                    label: 'Title',
                    type: 'input',
                    modifyRow: (row, val) => ({...row, title: val})
                }
            ]
        }
    ],
};
